import type { FC, ReactNode } from 'react'

import { motion, useScroll, useSpring } from 'motion/react'

export const ScrollProgress: FC = (): ReactNode => {
    const { scrollYProgress } = useScroll()
    const scaleX = useSpring(scrollYProgress, { stiffness: 160, damping: 30, restDelta: 0.001 })

    return (
        <motion.div
            aria-hidden='true'
            className='fixed inset-x-0 top-0 z-[60] h-1 origin-left bg-primary'
            style={{ scaleX }}
        />
    )
}
